// component
import SvgColor from "../../../components/svg-color";

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const navConfig =
  process.env.REACT_APP_NAME === "olybet"
    ? [
        {
          title: "Banners",
          path: "/dashboard/banners",
          icon: icon("image-outline"),
        },
        {
          title: "Bingo Games",
          path: "/dashboard/games",
          icon: icon("ic_blog"),
        },
        {
          title: "Pages",
          path: "/dashboard/pages",
          icon: icon("file-text-outline"),
        },
        {
          title: "Headshots",
          path: "/dashboard/headshots",
          icon: icon("image-outline"),
        },
      ]
    : [
        {
          title: "Bingo Games",
          path: "/dashboard/games",
          icon: icon("ic_blog"),
        },
        {
          title: "Pages",
          path: "/dashboard/pages",
          icon: icon("file-text-outline"),
        },
        {
          title: "Question Templates",
          path: "/dashboard/question-templates",
          icon: icon("ic_user"),
        },
        {
          title: "Headshots",
          path: "/dashboard/headshots",
          icon: icon("image-outline"),
        },
        {
          title: "Stats",
          path: "/dashboard/stats",
          icon: icon("ic_analytics"),
        },
      ];

export default navConfig;
